import { AuthBaseClient } from '../base-client';
import type { SearchResponse } from '@vagusx/shared';
import type { LocationResponse, CreateLocationRequest, UpdateLocationRequest } from './types';
import type { ProviderResponse } from '../provider/types';

/**
 * Client for location API endpoints.
 */
export class LocationClient extends AuthBaseClient {
  /**
   * List all locations.
   */
  async list(): Promise<SearchResponse<LocationResponse>> {
    return this.get<SearchResponse<LocationResponse>>('/api/locations');
  }

  /**
   * Get location by ID.
   */
  async getById(id: string): Promise<LocationResponse> {
    return this.get<LocationResponse>(`/api/locations/${id}`);
  }

  /**
   * Create a new location.
   */
  async create(data: CreateLocationRequest): Promise<LocationResponse> {
    return this.post<LocationResponse>('/api/locations', data);
  }

  /**
   * Update a location.
   */
  async update(id: string, data: UpdateLocationRequest): Promise<LocationResponse> {
    return this.patch<LocationResponse>(`/api/locations/${id}`, data);
  }

  /**
   * Delete a location.
   */
  async deleteLocation(id: string): Promise<void> {
    return this.delete<void>(`/api/locations/${id}`);
  }

  /**
   * Get all providers at a location.
   */
  async getProviders(locationId: string): Promise<ProviderResponse[]> {
    return this.get<ProviderResponse[]>(`/api/locations/${locationId}/providers`);
  }
}
